import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useMouseNavigationContext } from './MouseNavigationProvider';

export const NavigationDebugger: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { getNavigationState } = useMouseNavigationContext();
  const state = getNavigationState();

  if (!isVisible) {
    return (
      <TouchableOpacity
        style={styles.debugButton}
        onPress={() => setIsVisible(true)}
      >
        <Text style={styles.debugButtonText}>🐛</Text>
      </TouchableOpacity>
    );
  }

  return (
    <View style={styles.debugContainer}>
      <View style={styles.debugHeader}>
        <Text style={styles.debugTitle}>Navigation Debug</Text>
        <TouchableOpacity onPress={() => setIsVisible(false)}>
          <Text style={styles.closeButton}>✕</Text>
        </TouchableOpacity>
      </View>
      
      <View style={styles.debugContent}>
        <Text style={styles.debugText}>
          Can Go Back: {state.canGoBack ? 'Yes' : 'No'}
        </Text>
        <Text style={styles.debugText}>
          Can Go Forward: {state.canGoForward ? 'Yes' : 'No'}
        </Text>
        <Text style={styles.debugText}>
          Note: Forward navigation is limited by browser history
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  debugButton: {
    position: 'absolute',
    bottom: 20,
    right: 20,
    width: 50,
    height: 50,
    borderRadius: 25,
    backgroundColor: 'rgba(0,0,0,0.7)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  debugButtonText: {
    fontSize: 20,
  },
  debugContainer: {
    position: 'absolute',
    bottom: 80,
    right: 20,
    width: 300,
    backgroundColor: 'rgba(0,0,0,0.9)',
    borderRadius: 8,
    padding: 12,
    zIndex: 1000,
  },
  debugHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  debugTitle: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 14,
  },
  closeButton: {
    color: 'white',
    fontSize: 16,
    fontWeight: 'bold',
  },
  debugContent: {
    gap: 4,
  },
  debugText: {
    color: 'white',
    fontSize: 12,
  },
  debugSubtitle: {
    color: 'white',
    fontSize: 12,
    fontWeight: 'bold',
    marginTop: 8,
    marginBottom: 4,
  },
  historyItem: {
    color: 'rgba(255,255,255,0.8)',
    fontSize: 11,
    marginLeft: 8,
  },
});
